import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { CurrencyProvider } from './components/CurrencyContext';
export function App() {
  useEffect(() => {
    document.title = 'Comandos Eléctricos — Guía Profesional';
    // Microsoft Clarity
    if (typeof window !== 'undefined' && !(window as any).clarity) {
      const w = window as any;
      w.clarity = w.clarity || function () {
        ;
        (w.clarity.q = w.clarity.q || []).push(arguments);
      };
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/witra9hyna';
      document.head.appendChild(script);
    }
  }, []);
  useEffect(() => {
    // Facebook Pixel initialization
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      f.fbq = function () {
        f.fbq.callMethod ? f.fbq.callMethod.apply(f.fbq, arguments) : f.fbq.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = f.fbq;
      f.fbq.push = f.fbq;
      f.fbq.loaded = true;
      f.fbq.version = '2.0';
      f.fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '26721554970836062');
      f.fbq('track', 'PageView');
    }
    // Fire InitiateCheckout on every button click
    const handleButtonClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('button') || target.closest('a[role="button"]')) {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'InitiateCheckout');
        }
      }
    };
    document.addEventListener('click', handleButtonClick);
    return () => document.removeEventListener('click', handleButtonClick);
  }, []);
  return <CurrencyProvider data-id="element-0">
      <LandingPage data-id="element-1" />
    </CurrencyProvider>;
}